App.controller('ConfirmRegistrationCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$stateParams', 'authService', '$mdDialog', 'popUpService', function ($scope, $sce, $state, $http, Config, $stateParams, authService, $mdDialog, popUpService) {
	$scope.stateParams = $stateParams;

    $scope.acceptStatement = true;
    $scope.token = $scope.stateParams.token;
    console.log($scope.token);

    $scope.confirm = function() {

        if (!$scope.acceptStatement) {
            $scope.showPopUp('', 'Zaakceptuj oświadczenie', 'Aby potwierdzić rejestrację, musisz zaakceptować oświadczenie.', '');
            return 0;
        }

        authService.confirmRegistration($scope.token).then(function (data) {
            if (data.status === 200) {
                $state.go('root.login');
            } else {
                if (data.data.message === 'DuplicateIdentifierException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Podany PESEL/Numer paszportu został juz zarejestrowany w bazie.', text: '', target: ''});
                } else if (data.data.message === 'DuplicateLoginException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja zakończona', content: 'Potwierdzenie rejestracji zostało już dokonane.', text: 'Zaloguj się', target: 'root.login'});
                } else if (data.data.message === 'DuplicateEmailException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Podany adres e-mail jest już zajęty, użyj innego.', text: '', target: ''});
                } else if (data.data.message === 'TokenExpiredException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawny token', content: 'Token do potwierdzenia rejestracji jest niepoprawny, skontaktuj się z administratorem.', text: '', target: ''});
                } else {
                    popUpService.showPopUpWithError(data.data ,{head: 'Rejestracja nieudana', content:'Niestety nie udało się zarejestrować konta, skontaktuj się z administratorem.'});
                }
            }
        });
    }

    $scope.showPopUp = function(ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
}]);
